import React from "react";
import { WarningMessage } from "sprint-common-web";

export const AssetCreationWarning = (): JSX.Element => {
    return (
        <WarningMessage message="A new asset will be created on submit. Please make sure all information is correct. Changes will be applied only to the current asset, other related assets must be updated manually." />
    );
};
